import { cn } from "@/lib/utils";

/**
 * The side nav's shared class strings (docs/design-guidelines.md §12).
 *
 * Two surfaces, two row recipes, and nothing else spells them out:
 *   • the cream rail and panel — stone hover, a coral-100 pill when current;
 *   • the white sheets (the mobile drawer, the account menu) — coral-50 hover
 *     and pill.
 */

// The icon rail's width. The studio band and the search row take it too
// while the panel is hidden, so they stay centred on the rail even when the
// search pane is open beside it.
export const NAV_RAIL_WIDTH = "w-[4.75rem]";

// Hidden until hovered, then thin, so a long menu scrolls without a bar
// dividing the cream panel from the sheet.
export const NAV_SCROLLBAR =
  "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden " +
  "hover:[scrollbar-width:thin] hover:[scrollbar-color:theme(colors.stone.300)_transparent] " +
  "hover:[&::-webkit-scrollbar]:block hover:[&::-webkit-scrollbar]:w-1 " +
  "hover:[&::-webkit-scrollbar-track]:bg-transparent " +
  "hover:[&::-webkit-scrollbar-thumb]:rounded-full " +
  "hover:[&::-webkit-scrollbar-thumb]:bg-stone-300";

// The 10px label above a group of links. Deliberately not <Eyebrow>, which is
// the 11px/0.18em eyebrow for content sections.
export const NAV_GROUP_EYEBROW =
  "px-3 pb-1.5 text-[10px] font-semibold uppercase tracking-[0.22em] text-gray-400";

// The coral pill marking the current item on the cream chrome, and an item at
// rest there. Not TONES.brand (a -50/-600 tile for content): the chrome's pill
// is a shade deeper on purpose so it reads against cream, §12.
export const NAV_CURRENT_PILL = "bg-brand-100 font-medium text-brand-800";
export const NAV_REST_ITEM =
  "text-gray-600 hover:bg-stone-200/50 hover:text-gray-900";

/** A link row in the cream panel. */
export function panelRowClass(active) {
  return cn(
    "flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors duration-150",
    active ? NAV_CURRENT_PILL : NAV_REST_ITEM,
  );
}

/** A link row on a white sheet: the mobile drawer and the account menu. */
export function sheetRowClass(active) {
  return cn(
    "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors",
    active
      ? "bg-brand-50 font-medium text-brand-800"
      : "text-gray-700 hover:bg-brand-50 hover:text-brand-800",
  );
}
